module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sea-shore@2x_313f30.jpg";